<template>
  <div id="app" :class="$mq">
    <application-layout />
  </div>
</template>

<script>
import ApplicationLayout from '@/layouts/ApplicationLayout'

import { openPopup } from '@/utils/helpers'

export default {
  name: 'App',
  components: { ApplicationLayout },
  beforeDestroy () {
    window.removeEventListener('click', this.setClick, { passive: true })
  },
  mounted () {
    window.addEventListener('click', this.setClick, { passive: true })
  },
  methods: {
    openPopup,
    setClick ($el) {
      switch ($el.srcElement.id) {
        case 'HyptoPopup':
          this.openPopup(null)
          break
      }
    }
  }
}
</script>

<style>
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #1C2938;
    background: #F4F6F6;
  }
</style>
